

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  InvitationToken,
  ParticipantInvitation,
  ParticipantInvitationListDTO,
} from '../../../store/modules/projects/types/projects.types';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../../utils/date.util';
import { AuditSite } from '@/store/modules/audits/types/audits.types';

@Component({
  components: {},
})
export default class AuditInvitationList extends Vue {
  @Prop() public participantInvitations!: ParticipantInvitation[];
  @Prop() public auditSites!: AuditSite[];

  get invitations() {
    if (this.participantInvitations) {
      const data: ParticipantInvitationListDTO[] = this.participantInvitations.map(
        (invitation: ParticipantInvitation) => {
          return {
            userEmail: invitation.invitationToken.email,
            participantRole: invitation.role,
            participantSites: this.siteNames(invitation.siteIds),
            token: invitation.invitationToken,
          };
        },
      );

      return data.slice(0, 5);
    }
    return [];
  }

  public siteNames(siteIds: number[]): string[] {
    return this.auditSites
      .filter((as) => siteIds.includes(as.site.id))
      .map((as) => as.site.name);
  }

  get dayjs() {
    return dayjs;
  }

  public invitationDate(item: InvitationToken): string | null {
    return dayjs(item.updatedAt || item.createdAt).format(DATE_FORMAT) || null;
  }

  public invitationStatus(invitation: InvitationToken) {
    if (invitation.acceptedAt) {
      return 'Accepted';
    }

    if (new Date(invitation.expiredAt) <= new Date()) {
      return 'Expired';
    } else {
      return 'Pending';
    }
  }

  public handleNavigate() {
    this.$emit('changeActiveTab', '#participants');
  }
}
